module.exports = __webpack_public_path__ + "static/media/arrow-down.b10a5b11.svg";